
import { A2AAgent } from '../types';

export const emailAgents: A2AAgent[] = [
  {
    id: 'email-processor-agent',
    name: 'Email Processor Agent',
    isAvailable: true,
    capabilities: ['email-analysis', 'email-categorization', 'email-context-extraction', 'email-intent-detection', 'spam-detection'],
    description: 'Intelligently analyzes, categorizes, extracts context, and detects intent from emails.',
    category: 'specialized',
    version: '1.0',
    interfaces: ['a2a-messaging'],
    maxConcurrentTasks: 5,
  },
  {
    id: 'email-composer-agent',
    name: 'Email Composer Agent',
    isAvailable: true,
    capabilities: ['email-drafting', 'template-personalization', 'tone-adjustment', 'grammar-check', 'subject-line-generation'],
    description: 'AI-powered assistant for drafting, personalizing, and optimizing email content.',
    category: 'specialized',
    version: '1.0',
    interfaces: ['a2a-messaging'],
    maxConcurrentTasks: 4,
  },
  {
    id: 'email-scheduler-agent',
    name: 'Email Scheduler Agent',
    isAvailable: true,
    capabilities: ['email-sequencing', 'automated-follow-up-scheduling', 'send-time-optimization', 'campaign-management'],
    description: 'Manages automated email sequences, follow-ups, and optimal send times.',
    category: 'specialized',
    version: '1.0',
    interfaces: ['a2a-messaging', 'calendar-integration'],
    maxConcurrentTasks: 5,
  },
  {
    id: 'email-analytics-agent',
    name: 'Email Analytics Agent',
    isAvailable: true,
    capabilities: ['email-tracking', 'engagement-analysis', 'performance-reporting', 'ab-testing-support', 'roi-calculation'],
    description: 'Tracks email performance, analyzes engagement, and provides actionable insights.',
    category: 'specialized',
    version: '1.0',
    interfaces: ['a2a-messaging', 'data-visualization'],
    maxConcurrentTasks: 3,
  },
  {
    id: 'email-orchestrator-agent',
    name: 'Email Orchestrator Agent',
    isAvailable: true,
    capabilities: ['email-workflow-coordination', 'multi-agent-email-tasks', 'email-task-delegation'],
    description: 'Coordinates complex email workflows involving multiple specialized email agents.',
    category: 'executive', // Or specialized, depending on how it's used
    version: '1.0',
    interfaces: ['a2a-messaging'],
    maxConcurrentTasks: 5,
  },
  {
    id: 'email-template-agent',
    name: 'Email Template Agent',
    isAvailable: true,
    capabilities: ['template-management', 'dynamic-template-generation', 'template-sharing', 'template-versioning'],
    description: 'Manages creation, storage, and dynamic generation of email templates.',
    category: 'specialized',
    version: '1.0',
    interfaces: ['a2a-messaging'],
    maxConcurrentTasks: 3,
  },
  {
    id: 'email-sentiment-agent',
    name: 'Email Sentiment Agent',
    isAvailable: true,
    capabilities: ['sentiment-analysis', 'emotion-detection', 'tone-recommendation', 'communication-style-analysis'],
    description: 'Analyzes sentiment and tone in emails, providing recommendations for effective communication.',
    category: 'specialized',
    version: '1.0',
    interfaces: ['a2a-messaging'],
    maxConcurrentTasks: 4,
  },
  {
    id: 'email-compliance-agent',
    name: 'Email Compliance Agent',
    isAvailable: true,
    capabilities: ['pii-detection', 'policy-adherence-check', 'legal-disclaimer-insertion', 'gdpr-ccpa-compliance'],
    description: 'Ensures email content adheres to legal, regulatory, and company policies.',
    category: 'specialized',
    version: '1.0',
    interfaces: ['a2a-messaging'],
    maxConcurrentTasks: 3,
  },
  {
    id: 'email-integration-agent',
    name: 'Email Integration Agent',
    isAvailable: true,
    capabilities: ['external-email-sync', 'email-platform-api-management', 'email-account-configuration'],
    description: 'Manages integrations with external email platforms like Gmail, Outlook, etc.',
    category: 'specialized',
    version: '1.0',
    interfaces: ['a2a-messaging', 'api-integration'],
    maxConcurrentTasks: 2,
  },
];

